import { io } from 'socket.io-client'

import React, { useState, createContext, useEffect, useContext } from 'react'
import { EmpresaContext } from './empresa'
import { getRealtimeUrl } from '../utils/config'

const RealtimeContext = createContext()

function RealtimeProvider ({ children }) {
  const [socket, setSocket] = useState(null)
  const { empresaSelected } = useContext(EmpresaContext)

  useEffect(() => {
    if (empresaSelected) {
      const token = window.localStorage.getItem('wisepay-token')
      const url = getRealtimeUrl()
      const realtimeSocket = io(url, {
        extraHeaders: {
          authorization: token,
          empresa: empresaSelected.id
        }
      })

      setSocket(realtimeSocket)

      return () => {
        realtimeSocket.disconnect()
      }
    }
  }, [empresaSelected])

  return (
    <RealtimeContext.Provider
      value={{ socket }}
    >
      {children}
    </RealtimeContext.Provider>
  )
}

export { RealtimeProvider, RealtimeContext }
